import { connect } from 'react-redux';
import { Component } from 'react';
import { breakpoints } from 'styles';
import { Badge } from 'components/common';
import { TaskPointsBadge } from '.';

const ScormAnswer = connect((state) => ({
  messages: state.messages,
  theme: state.theme
}))(
  class extends Component {
    getStatusSummary(label, summary, isScore = false) {
      const { messages, theme } = this.props;

      return (
        <div className="status">
          <div className="status-content">
            <div className="status-text">{label}</div>
            <div className="status-info">
              {isScore ? (
                <div className="status-percentage">
                  {isNaN(summary) ? (
                    <div className="status-percentage-content">
                      {messages.commonUnknown}
                    </div>
                  ) : (
                    <div className="status-percentage-content">
                      {`${Math.round(summary)}%`}
                      <div className="status-percentage-indicator">
                        <div
                          className="status-percentage-indicator-fill"
                          style={{ width: `${Math.round(summary)}%` }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="status-summary">{summary}</div>
              )}
            </div>
          </div>
          <style jsx>{`
            .status {
              background-color: white;
              border-radius: 5px;
              color: ${theme.textColorLight};
              font-size: 1.4rem;
              padding: 8px 10px;
            }
            .status:not(:first-child) {
              margin-top: 10px;
            }
            .status-text {
              display: flex;
              flex-grow: 1;
              flex-shrink: 1;
            }
            .status-text-inner {
              word-break: break-word;
            }
            .status-text-inner :global(p) {
              margin: 8px 0 0;
            }
            .status-text-inner :global(p:first-child) {
              margin-top: 0;
            }
            .status-info {
              display: flex;
            }
            .status-correct {
              flex-grow: 1;
              flex-shrink: 0;
              font-size: 1.2rem;
              margin-left: 10px;
              min-width: 0;
              text-align: right;
            }
            .status-percentage-content {
              align-items: center;
              background-color: ${theme.lightGrey};
              border-radius: 4px;
              display: flex;
              font-size: 1.2rem;
              font-weight: 600;
              padding: 1px 5px;
              white-space: nowrap;
              width: 85px;
              justify-content: center;
            }
            .status-percentage-indicator {
              background-color: ${theme.lightGreyDark};
              border-radius: 3px;
              display: inline-block;
              height: 6px;
              margin-left: 5px;
              overflow: hidden;
              width: 50px;
            }
            .status-summary {
              font-size: 1.5rem;
            }
            @keyframes statusPercentageFill {
              0% {
                width: 0;
              }
            }
            .status-percentage-indicator-fill {
              animation: statusPercentageFill 1s;
              background-color: ${theme.successColor};
              height: 100%;
            }
            @media (max-width: ${breakpoints.small - 1}px) {
              .status-info {
                margin-top: 10px;
              }
            }
            @media (min-width: ${breakpoints.small}px) {
              .status-content {
                display: flex;
              }
            }
          `}</style>
        </div>
      );
    }

    handleImageError = (ev) => {
      ev.target.src = '/static/img/block_placeholder.png';
      ev.target.parentElement.classList.add('broken');
    };

    render() {
      const {
        hideScore = false,
        maxScore,
        messages,
        completion,
        points,
        showPreview,
        success,
        score,
        task,
        theme
      } = this.props;

      const title = task?.data?.file?.title
        ?.replace(/.zip$/, '')
        .replace('_', ' ');

      const blockThumbnailUrl = task?.data?.file?.baseUrl?.replace(
        /uploads\/decompressed.*$/,
        `blocks/${task.id}.png`
      );

      const completionIcon = (
        <Badge
          category="success-light"
          icon="check"
          isRounded={false}
          size="small"
          text={messages.tasksScormStatusCompletion}
        />
      );
      const successIcon = (
        <Badge
          category="success-light"
          icon="check"
          isRounded={false}
          size="small"
          text={messages.tasksScormStatusSuccess}
        />
      );
      const inProgressIcon = (
        <Badge
          category="default"
          icon="hourglass-start"
          isRounded={false}
          size="small"
          text={messages.commonInProgress}
        />
      );
      const failIcon = (
        <Badge
          category="error-light"
          icon="times"
          isRounded={false}
          size="small"
          text={messages.readerCompletionFailed}
        />
      );

      return (
        <div className="answer">
          {showPreview && (
            <div className="block-preview">
              <img
                alt={title}
                title={title}
                onError={this.handleImageError}
                src={blockThumbnailUrl}
              />
            </div>
          )}
          <div
            className={'summary' + (showPreview ? ' summary-with-preview' : '')}
          >
            {this.getStatusSummary(
              messages.tasksScormStatusCompletion,
              completion > 0 ? completionIcon : inProgressIcon
            )}
            {!isNaN(success) &&
              this.getStatusSummary(
                messages.tasksScormStatusSuccess,
                success >= 0.8 ? successIcon : failIcon
              )}
            {!isNaN(score) &&
              this.getStatusSummary(
                messages.tasksScormStatusScore,
                score * 100,
                true
              )}
          </div>

          {!hideScore ? (
            <TaskPointsBadge
              hideSuccessBadge={true}
              maxPoints={maxScore}
              points={points}
            />
          ) : null}

          <style jsx>{`
            .answer {
              color: ${theme.textColor};
              font-size: 1.5rem;
            }
            .content {
              background-color: white;
              border-radius: 5px;
              padding: 15px;
            }
            .block-preview {
              height: 124px;
              width: 160px;
              overflow: hidden;
              position: relative;
              border: 1px solid ${theme.lightGreyDark};
              border-radius: 5px;
              background: white;
              display: inline-block;
            }
            .block-preview img {
              max-width: 160px;
            }
            .summary {
              display: inline-block;
              vertical-align: top;
              width: 100%;
            }
            .summary-with-preview {
              margin-left: 10px;
              width: calc(100% - 170px);
            }
          `}</style>
        </div>
      );
    }
  }
);

export default ScormAnswer;
